import jwt from '../utils/jwt';
export default class Storage {
    constructor(key) {
        this.key = key;
    }

    setKey(key) {
        this.key = key;
    }

    get localStorage() {
        // LocalStorage proxy to allow browsers that block localStorage
        try {
            // Try access
            let storage = window.localStorage;

            // Try API
            storage.getItem('test');
            return storage;
        } catch(e) {
            return {
                setItem: () => {},
                removeItem: () => {},
                getItem: () => null
            };
        }
    }

    store(data) {
        return this.localStorage.setItem(this.key, JSON.stringify(data));
    }

    remove() {
        return this.localStorage.removeItem(this.key);
    }

    retrieve() {
        return JSON.parse(this.localStorage.getItem(this.key)) || {};
    }

    hasLocalValue() {
        let value = this.retrieve();
        return Object.keys(value).length && value.step && value.widget && this.isTokenValid();
    }

    activeTab() {
        let { active_tab_id } = this.retrieve();
        return active_tab_id;
    }

    isActiveTab(id) {
        return this.activeTab() === id;
    }

    isTokenValid() {
        let { token } = this.retrieve();

        if(!token) {
            return false;
        }

        let { payload: { exp }} = jwt.parse(token);

        // Token expired
        if(Date.now() > (exp * 1000)) {
            // We can safely remove item since it's expired
            return false;
        }

        return true;
    }


    // uuid is the current tab
    write({ uuid=null, step=null, widget=null, token=null, last_update=null }) {
        let data = {
            active_tab_id: uuid,
            widget,
            token,
            step,
            last_update: last_update || Date.now()
        };

        this.store(data);
    }
}
